import React from "react";
import { useAuth } from "../../../hooks/auth-context";

/**
 * This component shows or hides its children if a user has certain role
 * @param param0
 * @returns
 */
const NBRoleAccessControlComponent = ({
  children,
  roles,
  hiddenChildren
}) => {
  const {
    currentUser
  } = useAuth();
  if (currentUser.user && currentUser.hasRole(roles)) return /*#__PURE__*/React.createElement(React.Fragment, null, children);else return hiddenChildren ? /*#__PURE__*/React.createElement(React.Fragment, null, hiddenChildren) : null;
};
export { NBRoleAccessControlComponent };